import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import {
  P00058ProgrammeFiltrationAuto,
  P00058ProgrammeFiltrationManuel,
} from '../../../Enum/P00058ProgrammeFiltrationAuto';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';

@Component({
  selector: 'app-p00058-card-filtration-status',
  templateUrl: './p00058-card-filtration-status.component.html',
  styleUrls: ['./p00058-card-filtration-status.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe, SmallTuileComponent],
})
export class P00058CardFiltrationStatusComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  getStatus() {
    const pvSVitesseCouranteRPM = this.actionStack!.getValue(
      'pvSVitesseCouranteRPM',
    );
    const pvPUniteConsignePompe = this.actionStack!.getValue(
      'pvPUniteConsignePompe',
    );
    const pvSVitesseMaxRpm = this.actionStack!.getValue('pvSVitesseMaxRpm');

    if (pvSVitesseCouranteRPM === 0) {
      return 'P0003601.card.status.stop';
    } else {
      if (pvPUniteConsignePompe === 0) {
        const pourcentage = Math.round(
          (pvSVitesseCouranteRPM * 100) / pvSVitesseMaxRpm,
        );
        return pourcentage + ' %';
      } else {
        return (
          pvSVitesseCouranteRPM +
          ' ' +
          this.translateService.instant('P00058.installation.rpm')
        );
      }
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getButtons(): TuileButtonProps[] {
    const vitesseManuelle =
      this.actionStack!.getValue('pvCProgrammeManuel') ?? 0;
    const programmeFiltrationAuto =
      this.actionStack!.getValue('pvCProgrammeAuto') ?? 0;

    let res = 'fa-kit fa-vs-v1';

    if (vitesseManuelle === 0) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-max';
    }

    let res2 = 'fa-kit fa-vs-v1';

    if (programmeFiltrationAuto === 0) {
      res2 = 'fa-kit fa-picto-horlogeete';
    } else if (programmeFiltrationAuto === 1) {
      res2 = 'fa-kit fa-picto-horlogehiver';
    } else if (programmeFiltrationAuto === 2) {
      res2 = 'fa-kit fa-picto-horloge72h';
    } else if (programmeFiltrationAuto === 3) {
      res2 = 'fa-kit fa-vs-v2';
    }

    return [
      {
        title: 'P00058.card.state.filtration.status.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00058.card.state.filtration.status.manuel',
        icon: res,
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00058.card.state.filtration.status.auto',
        icon: res2,
        color: 'color-orange',
        status: 'active',
      },
      {
        title: 'P00058.card.state.filtration.status.auto',
        icon: 'fa-kit fa-picto-ecremage',
        color: 'color-orange',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.FILTRATION_VS,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.filtration'),
    );
  }

  protected readonly P00058ProgrammeFiltrationManuel =
    P00058ProgrammeFiltrationManuel;
  protected readonly P00058ProgrammeFiltrationAuto =
    P00058ProgrammeFiltrationAuto;
}
